import React, { Fragment } from 'react';
import List from './List';
import Detail from './Detail';



export default function Content() {
  return (
    <Fragment>
      <List />
      <Detail />
    </Fragment>
  )
}